import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Text from "@/components/ui/text";
import ConfirmationModal from "@/components/layouts/ConfirmationModal";
import { useDeleteQuestionnaireMutation } from "@/pages/deals/hooks";

const TRANSLATION_PREFIX =
  "settings.deals.workflow.workflowDetailedView.removeFromStageModal";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isDeleteConfirmed: boolean;
  setIsDeleteConfirmed: React.Dispatch<React.SetStateAction<boolean>>;
  stageId: string | undefined;
  questionnaireId: string | undefined;
  onDelete?: () => void;
}

const RemoveFromStageModal: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  isDeleteConfirmed,
  setIsDeleteConfirmed,
  stageId,
  questionnaireId,
  onDelete
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const deleteQuestionnaireMutation = useDeleteQuestionnaireMutation();

  const handleDeleteWorkflow = async () => {
    if (!stageId || !questionnaireId) {
      console.error("Missing stageId or questionnaireId");
      return;
    }

    try {
      await deleteQuestionnaireMutation.mutateAsync({
        pathParams: {
          questionnaireId
        }
      });

      setIsOpen(false);
      navigate(`/settings/deals/stages/${stageId}`);
      onDelete?.();
    } catch (error) {
      console.error("Failed to delete questionnaire:", error);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t(`${TRANSLATION_PREFIX}.title`)}
      confirmationText={
        <div className="flex flex-col gap-4">
          <Text>{t(`${TRANSLATION_PREFIX}.text1`)}</Text>
          <Text>{t(`${TRANSLATION_PREFIX}.text2`)}</Text>
        </div>
      }
      handleSubmit={handleDeleteWorkflow}
      submitButtonText={t("remove")}
      checkboxLabel={t(`${TRANSLATION_PREFIX}.checkboxLabel`)}
      isCheckboxRequired={true}
      onCheckboxChange={setIsDeleteConfirmed}
      isCheckboxChecked={isDeleteConfirmed}
    />
  );
};

export default RemoveFromStageModal;
